import React, { Component } from 'react';
import moment from 'moment';
import { Icon } from 'antd';
import ReactHtmlParser from 'react-html-parser';

const JournalShortNames = {
  "asian journal of dairy and food research": "AJDFR",
  "bhartiya krishi anusandhan patrika": "BKAP",
  "agricultural reviews": "AR",
  "indian journal of agricultural research": "IJOAR",
  "legume research": "LR",
  "agricultural science digest": "ASD",
  "indian journal of animal research": "IJAR",
};

class RecentUserActivity extends Component {
  getJournalShortName = (journal) => {
    if (!journal) return 'General';
    const normalizedKey = journal.trim().toLowerCase();
    return JournalShortNames[normalizedKey] || journal.toUpperCase();
  };

  getStatusStyle = (status) => {
    if (!status) return { background: '#edf2fd', color: '#4b6fb3' };
    const s = status.toLowerCase();

    if (s.includes('submitted'))                       return { background: '#f6ffed', color: '#52c41a' };
    if (s.includes('under process') || s === 'under process') return { background: '#e6f4ff', color: '#1890ff' };
    if (s.includes('reviewer') || s.includes('under review'))   return { background: '#f3effb', color: '#722ed1' };
    if (s.includes('reviewed comments') || s.includes('reviewed manuscript')) return { background: '#e6fffb', color: '#13c2c2' };
    if (s.includes('comments to author'))              return { background: '#fff7e6', color: '#fa8c16' };
    if (s.includes('revised'))                         return { background: '#fff2e8', color: '#ff7a45' };
    if (s.includes('approved'))                        return { background: '#e6fffb', color: '#36cfc9' };
    if (s.includes('accepted'))                        return { background: '#e6f7ff', color: '#40a9ff' };
    if (s.includes('compos'))                          return { background: '#fff0f6', color: '#eb2f96' };
    if (s.includes('galley') || s.includes('proof'))   return { background: '#fffbe6', color: '#faad14' };
    if (s.includes('doi'))                             return { background: '#f9f0ff', color: '#9254de' };
    if (s.includes('online'))                          return { background: '#f0fff4', color: '#2f8f65' };
    if (s.includes('publish'))                         return { background: '#f0fff4', color: '#389e0d' };
    if (s.includes('delet'))                           return { background: '#fff1f0', color: '#ff4d4f' };
    if (s.includes('withdraw'))                        return { background: '#f5f5f5', color: '#8c8c8c' };

    return { background: '#edf2fd', color: '#4b6fb3' };
  };

  render() {
    const { data } = this.props;

    // Reads user-specific activities returned by getNewDashboardStats 👈
    const activityList = (data && (data.recentUserActivities || data.recentArticles))
      ? (data.recentUserActivities || data.recentArticles)
      : [];

    return (
      <div className={'adminCard manuscriptsCard'}>
        <div className={'adminCardHeader'}>
          <div className={'adminCardTitleBlock'}>
            <div className={'adminCardTitle'}>User Activity</div>
            <div className={'adminCardSubtitle'}>Recent actions performed by you</div>
          </div>
        </div>

        <div className={'cardDivider'}></div>

        <div className={'msTable'}>
          <div className={'msTableHeader'}>
            <div className={'msCol msCol-main'}>Activity / Manuscript</div>
            <div className={'msCol msCol-journal'}>Journal</div>
            <div className={'msCol msCol-date'}>Date</div>
            <div className={'msCol msCol-status'}>Status</div>
            <div className={'msCol msCol-editor'}>User</div>
            <div className={'msCol msCol-action'}></div>
          </div>

          {activityList.map((item, key) => {
            const articleObj = (item && typeof item.articleId === 'object' && item.articleId !== null) ? item.articleId : {};
            const journalObj = (item && typeof item.journalId === 'object' && item.journalId !== null) ? item.journalId : {};
            const userObj = (item && typeof item.operatedByUserId === 'object' && item.operatedByUserId) ? item.operatedByUserId : {};

            const activityTitle = item.message
              || item.activity
              || articleObj.manuScriptTitle
              || articleObj.title
              || articleObj.articleTitle
              || 'User Action';

            const articleNo = item.articleNo || articleObj.articleNo || '';
            const author = articleObj.correspondingAuthor || item.correspondingAuthor || '';

            const rawJournalName = journalObj.shortName
              || journalObj.title
              || journalObj.journalTitle
              || journalObj.journalName
              || journalObj.name
              || articleObj.journalTitle
              || articleObj.journalName
              || articleObj.journal
              || item.journal
              || '';

            const journalShortName = (journalObj.shortName && journalObj.shortName.length <= 6)
              ? journalObj.shortName
              : this.getJournalShortName(rawJournalName);

            const dateVal = item.createdAt || item.time || item.updatedAt || articleObj.submittedDate;
            const currentStatus = item.status || item.articleStatus || articleObj.articleStatus || 'Completed';

            const userName = userObj.name
              || item.userName
              || articleObj.editorName
              || item.editorName
              || 'Admin';

            return (
              <div className={'msTableRow'} key={key}>
                <div className={'msCol msCol-main'}>
                  <div className={'msTitle'}>{ReactHtmlParser(activityTitle)}</div>
                  {(articleNo || author) && (
                    <div className={'msMeta'}>
                      {articleNo}
                      {author ? ` · ${author}` : ''}
                    </div>
                  )}
                </div>

                <div className={'msCol msCol-journal'}>
                  <span className={'journalBadge'}>{journalShortName}</span>
                </div>

                <div className={'msCol msCol-date'}>
                  {dateVal ? moment(dateVal).format('DD MMM YYYY') : 'N/A'}
                </div>

                <div className={'msCol msCol-status'}>
                  <span
                    className={'statusBadge'}
                    style={this.getStatusStyle(currentStatus)}
                  >
                    <span className={'statusDot'}></span>
                    {currentStatus}
                  </span>
                </div>

                <div className={'msCol msCol-editor'}>{userName}</div>

                <div className={'msCol msCol-action'}>
                  <Icon type={'more'} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default RecentUserActivity;